export default "__VITE_PUBLIC_ASSET__658435e3__"